import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { IMKitHeaderLookupLayout } from '../../../../common/lookups/Layouts/ImLayouts';
import { KitLayout } from '../Layout';
import KitDetailTab from "./KitDetailTab";
function KitTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [sourceId, setsourceId] = useState(props.formFields?.R_ITEMKITTCODE || '');

    const handleKitFormLoad = useCallback(() => {
        props.kitFormLookupsLoad();
    }, []);
  
    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleKitFieldChange(name, value);
    }, []);
    return (
        <div className="row">
                <FormField
                    currrentUser={currentUser}
                    layoutId='9FF031BF-8C37-48E9-9A9A-F9BEA55B29D4'
                    layoutName='IMItemDataEntryKitForm'
                    defaultFormSchema={KitLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleKitFormLoad}
                    handleSelectedItemChange={handleSelectionChange}
                />
            <div className="col-md-12">
                    <KitDetailTab formFields={props.formFields}   />
            </div>


        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(KitTab);
